import React from 'react';

export function PhoneColumnFormatter(cellContent) {
  const getPhoneNumber = (item) => {
    if (item) {
      return (
        <div dir={'ltr'} className="text-dark-75 font-weight-bolder d-block font-size-lg text-nowrap">
          {item}
        </div>
      );
    } else return ''
  };

  return cellContent.map(getPhoneNumber)
}
